import { INew_TableAction } from '@lla-platform/core/core-data-access'
import { ITargetsDailyAverageRequest } from '../../interfaces/targets-daily-average.interface'
import { ITargetsHistoryRequest } from '../../interfaces/targets-history.interface'
import { ISaveLocationMonthlyTargetsRequest } from '../../interfaces/monthly-targets.interface'

export class GetAvailableWeeksForWeeklyTarget {
  static readonly type = '[WeeklyTarget] Get Available Weeks For Weekly Target'
}

export class GetShopsTargets {
  static readonly type = '[WeeklyTarget] Get Shops Targets'
  constructor(public weekNumber: number) {}
}

export class GetShopsTargetsComps {
  static readonly type = '[WeeklyTarget] Get Shops Targets Comps'
  constructor(public weekNumber: number) {}
}

export class GetTargetsHistory {
  static readonly type = '[WeeklyTarget] Get Targets History'
  constructor(public payload: ITargetsHistoryRequest) {}
}

export class GetTargetsDailyAverage {
  static readonly type = '[WeeklyTarget] Get Targets Daily Average'
  constructor(public payload: ITargetsDailyAverageRequest) {}
}

export class GetYearlyTargets {
  static readonly type = '[WeeklyTarget] Get Yearly Targets'
  constructor(
    public info: INew_TableAction,
    public year: number
  ) {}
}

export class AdminGetYearlyTargets {
  static readonly type = '[WeeklyTarget] Admin Get Yearly Targets'
  constructor(
    public info: INew_TableAction,
    public year: number
  ) {}
}

export class AdminGetMonthlyTargets {
  static readonly type = '[WeeklyTarget] Admin Get Monthly Targets'
  constructor(
    public info: INew_TableAction,
    public year: number
  ) {}
}

export class AdminGetLocationMonthlyTargets {
  static readonly type = '[WeeklyTarget] Admin Get Location Monthly Targets'
  constructor(
    public locationId: string,
    public year: number
  ) {}
}

export class AdminSaveLocationMonthlyTargets {
  static readonly type = '[WeeklyTarget] Admin Save Location Monthly Targets'
  constructor(
    public locationId: string,
    public payload: ISaveLocationMonthlyTargetsRequest
  ) {}
}

export class ResetLocationMonthlyTargets {
  static readonly type = '[WeeklyTarget] Reset Location Monthly Targets'
}
